import { render, staticRenderFns } from "./flyProduct.vue?vue&type=template&id=09c9cb89&scoped=true"
import script from "./flyProduct.vue?vue&type=script&lang=js"
export * from "./flyProduct.vue?vue&type=script&lang=js"
import style0 from "./flyProduct.vue?vue&type=style&index=0&id=09c9cb89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c9cb89",
  null
  
)

export default component.exports